export default {
  nav: {
    home: 'Startseite',
    categories: 'Kategorien',
    cart: 'Warenkorb',
    orders: 'Bestellungen',
    wishlist: 'Wunschliste',
    vendor: 'Verkäufer',
    notifications: 'Benachrichtigungen',
    profile: 'Profil',
    addresses: 'Adressen',
    paymentMethods: 'Zahlungsmethoden',
    security: 'Sicherheit',
    settings: 'Einstellungen',
    storyEditor: 'Story Editor',
    more: 'Mehr',
    closeMenu: 'Menü schließen',
    language: 'Sprache',
    help: 'Hilfe & Support',
  },
  header: {
    welcome: 'Willkommen',
    searchPlaceholder: 'Produkte, Marken und Kategorien durchsuchen...',
    searchMobile: 'Suchen...',
    search: 'Suchen',
    delivery: 'Lieferung',
    pickup: 'Abholung',
    selectAddress: 'Adresse auswählen',
    selectLocation: 'Standort auswählen',
    schedule: 'Zeitplan',
    setAddress: 'Adresse festlegen',
    inStorePickup: 'Abholung im Geschäft',
    notifications: 'Benachrichtigungen',
    customer: 'Kunde',
    guest: 'Gast',
    address: 'Adresse',
    scheduledSelected: 'Geplante Lieferung ausgewählt',
    courierSelected: 'Kurierlieferung ausgewählt',
    pickupSelected: 'Abholung im Geschäft ausgewählt',
    searchingFor: 'Suche nach',
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    add: 'Hinzufügen',
    confirm: 'Bestätigen',
    back: 'Zurück',
    backToProfile: 'Zurück zum Profil',
    next: 'Weiter',
    close: 'Schließen',
    loading: 'Wird geladen...',
    error: 'Fehler',
    success: 'Erfolg',
    empty: 'Leer',
    seeAll: 'Alle anzeigen',
    appName: 'Bazaarak',
    appNameEn: 'Bazaarak',
    currency: 'EUR',
    viewAll: 'Alle anzeigen',
    items: 'Artikel',
    store: 'Shop',
    clear: 'Löschen',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    enable: 'Aktivieren',
  },
  auth: {
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    email: 'E-Mail',
    password: 'Passwort',
    phone: 'Telefon',
    forgotPassword: 'Passwort vergessen',
    signInRequired: 'Anmeldung erforderlich',
    addressSignInPrompt: 'Bitte melden Sie sich an, um Ihre Lieferadressen zu verwalten',
    unauthorized: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    createAccount: 'Konto erstellen',
    welcomeBack: 'Willkommen zurück!',
    createYourAccount: 'Konto erstellen',
    customer: 'Kunde',
    vendor: 'Verkäufer',
    name: 'Name',
    fullName: 'Vollständiger Name',
    storeName: 'Shopname',
    confirmPassword: 'Passwort bestätigen',
    enterYourName: 'Ihren Namen eingeben',
    emailOrUsername: 'E-Mail / Benutzername',
    enterEmailOrUsername: 'E-Mail oder Benutzernamen eingeben',
    enterYourPassword: 'Ihr Passwort eingeben',
    confirmYourPassword: 'Passwort bestätigen',
    enterStoreName: 'Shopnamen eingeben',
    enterPhoneNumber: '+49 176 1234 5678',
    rememberMe: 'Angemeldet bleiben',
    orContinueWith: 'Oder weiter mit',
    continueWithGoogle: 'Mit Google fortfahren',
    continueWithApple: 'Mit Apple fortfahren',
    noAccount: 'Noch kein Konto?',
    hasAccount: 'Bereits ein Konto?',
    backToHome: 'Zurück zur Startseite',
    signingIn: 'Anmeldung...',
    creatingAccount: 'Konto wird erstellt...',
    verifiedVendor: 'Verifizierter Verkäufer',
  },
  product: {
    addToCart: 'In den Warenkorb',
    addToWishlist: 'Zur Wunschliste',
    buyNow: 'Jetzt kaufen',
    outOfStock: 'Nicht verfügbar',
    discount: 'Rabatt',
    price: 'Preis',
    originalPrice: 'Originalpreis',
    reviews: 'Bewertungen',
    description: 'Beschreibung',
    related: 'Ähnliche Produkte',
    inStock: 'verfügbar',
    quantity: 'Menge',
    availability: 'Verfügbarkeit',
    selectVariant: 'Variante wählen',
    save: 'Sparen',
    notFound: 'Produkt nicht gefunden',
    notFoundDesc: 'Dieses Produkt existiert nicht oder wurde entfernt.',
    browseProducts: 'Produkte durchsuchen',
    home: 'Startseite',
    addingToCart: 'Wird hinzugefügt...',
    addingToWishlist: 'Wird hinzugefügt...',
    addedToCart: 'zum Warenkorb hinzugefügt!',
    addedToWishlist: 'Zur Wunschliste hinzugefügt!',
    failedToLoad: 'Produkt konnte nicht geladen werden',
    failedToAddCart: 'Zum Warenkorb hinzufügen fehlgeschlagen',
    failedToAddWishlist: 'Zur Wunschliste hinzufügen fehlgeschlagen',
    viewCart: 'Warenkorb anzeigen',
    products: 'Produkte',
    nSellers: '{{count}} Verkäufer',
    fromPrice: 'ab',
    priceRange: 'ab €{{from}} bis €{{to}}',
    chooseStore: 'Shop wählen',
    soldBySelected: 'Verkauft vom ausgewählten Shop',
    availableAtStores: 'Verfügbar in {{count}} Shops',
    store: 'Shop',
    multipleVariants: '{{count}} Optionen',
  },
  cart: {
    title: 'Warenkorb',
    empty: 'Ihr Warenkorb ist leer',
    emptyDesc: 'Beginnen Sie mit dem Einkaufen, um Artikel hinzuzufügen',
    total: 'Gesamt',
    checkout: 'Zur Kasse',
    continueShopping: 'Weiter einkaufen',
    orderSummary: 'Bestellübersicht',
    subtotal: 'Zwischensumme',
    shipping: 'Versand',
    tax: 'Steuer (19%)',
    discount: 'Rabatt',
    couponCode: 'Gutscheincode',
    enterCode: 'Code eingeben',
    apply: 'Anwenden',
    couponApplied: 'Gutschein angewendet (10% Rabatt)',
    free: 'KOSTENLOS',
    processing: 'Wird verarbeitet...',
    secureCheckout: 'Sicherer Checkout mit Stripe',
    signIn: 'Bitte anmelden',
    signInDesc: 'Anmelden, um den Warenkorb zu sehen',
    itemsInCart: 'Artikel im Warenkorb',
    each: 'je',
  },
  categories: {
    browse: 'Kategorien durchsuchen',
    explore: 'Entdecken Sie unsere umfangreiche Kollektion in allen Kategorien',
    all: 'Alle Kategorien',
    electronics: 'Elektronik',
    fashion: 'Mode & Kleidung',
    home: 'Haus & Garten',
    sports: 'Sport & Outdoor',
    books: 'Bücher & Medien',
    beauty: 'Schönheit & Gesundheit',
    toys: 'Spielzeug & Spiele',
    automotive: 'Automotive',
    jewelry: 'Schmuck & Uhren',
    pet: 'Tierbedarf',
    office: 'Bürobedarf',
    productsAvailable: 'Produkte verfügbar',
    subcategories: 'Unterkategorien',
    noProductsFound: 'Keine Produkte gefunden für',
    products: 'Produkte',
  },
  home: {
    browseByCategory: 'Nach Kategorie einkaufen',
    browseCategoryDesc: 'Entdecken Sie unser breites Sortiment an Premium-Kategorien',
    featuredProducts: 'Empfohlene Produkte',
    featuredDesc: 'Handverlesene Artikel nur für Sie',
    nearYouProducts: 'In Ihrer Nähe jetzt',
    nearYouDesc: 'Ausgewählt für Ihre Region und Ortszeit',
    topProducts: 'Top-Produkte',
    topProductsDesc: 'Die meistverkauften Artikel diese Woche',
    sold: 'verkauft',
    youMightLike: 'Das könnte Ihnen gefallen',
    youMightLikeDesc: 'Ausgewählte Produkte aus Ihren Lieblingsshops',
    trendingNow: 'Aktuell im Trend',
    trendingDesc: 'Bleiben Sie mit den neuesten Trends vorne',
    premiumMarketplace: 'Premium Marktplatz',
    heroTitle1: 'Entdecken Sie',
    heroTitle2: 'Premium Produkte',
    heroDesc: 'Erleben Sie luxuriöses Einkaufen mit unserer ausgewählten Kollektion von Premium-Marken und exklusiven Produkten.',
    exploreNow: 'Jetzt entdecken',
    becomeVendor: 'Verkäufer werden',
    products: 'Produkte',
    vendors: 'Verkäufer',
    happyCustomers: 'Zufriedene Kunden',
    deliverTo: 'Liefern an',
    selectAddress: 'Adresse auswählen',
    schedule: 'Zeitplan',
    selectDateTime: 'Datum & Zeit auswählen',
    popularSearches: 'BELIEBTE SUCHEN',
    shopNow: 'Jetzt kaufen',
    explore: 'Erkunden',
    summerCollection: 'Sommerkollektion 2024',
    summerDesc: 'Entdecken Sie die heißesten Trends dieser Saison',
    smartHome: 'Smart Home Essentials',
    smartHomeDesc: 'Verwandeln Sie Ihren Lebensraum',
    wellness: 'Wellness & Selfcare',
    wellnessDesc: 'Premium-Produkte für Ihr Wohlbefinden',
    fashion: 'Mode',
    tech: 'Tech',
    beauty: 'Schönheit',
    selectDeliveryAddress: 'Lieferadresse auswählen',
    scheduleDelivery: 'Lieferung planen',
    addNewAddress: 'Neue Adresse hinzufügen',
    selectDate: 'Datum auswählen',
    selectTimeSlot: 'Zeitfenster auswählen',
    confirmSchedule: 'Zeitplan bestätigen',
    topVendors: 'Top Shops',
    topVendorsDesc: 'Vertrauenswürdige Geschäfte in Ihrer Nähe',
    topRatedNearYou: 'Top bewertet in Ihrer Nähe',
    discoverWhatYouLike: 'Entdecken Sie, was Ihnen gefällt',
    sponsored: 'Gesponsert',
    filter: {
      'all': 'Alle',
      'wishlist': 'Wunschliste',
      'on-sale': 'Im Angebot',
      'free-shipping': 'Kostenloser Versand',
      'new-arrivals': 'Neuheiten',
      'best-seller': 'Bestseller',
      'top-rated': 'Top Bewertet',
      'price-drop': 'Preissturz',
      'express': 'Express',
      'premium': 'Premium',
    },
    topStores: 'Top Shops',
    since: 'Seit',
  },
  orders: {
    title: 'Meine Bestellungen',
    totalOrders: 'Gesamtbestellungen',
    noOrders: 'Keine Bestellungen gefunden',
    noOrdersDesc: 'Beginnen Sie mit dem Einkaufen!',
    signIn: 'Bitte anmelden',
    signInDesc: 'Anmelden, um Bestellungen zu sehen',
    all: 'Alle',
    processing: 'In Bearbeitung',
    shipped: 'Versendet',
    delivered: 'Geliefert',
    cancelled: 'Storniert',
    orderedOn: 'Bestellt am',
    estDelivery: 'Lieferung ca.:',
    viewDetails: 'Details anzeigen',
    hideDetails: 'Details ausblenden',
    track: 'Verfolgen',
    orderItems: 'Bestellartikel',
    priceDetails: 'Preisdetails',
    shippingAddress: 'Lieferadresse',
    tracking: 'Sendungsnummer:',
    subtotal: 'Zwischensumme',
    shipping: 'Versand',
    tax: 'Steuer (19%)',
    total: 'Gesamt',
    item: 'Artikel',
    items: 'Artikel',
    qty: 'Menge:',
  },
  profile: {
    title: 'Profil',
    backToHome: 'Zurück zur Startseite',
    editProfile: 'Profil bearbeiten',
    saveChanges: 'Änderungen speichern',
    memberSince: 'Mitglied seit',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    myOrders: 'Meine Bestellungen',
    viewAllPurchases: 'Alle Käufe anzeigen',
    savedItems: 'gespeicherte Artikel',
    manageLocations: 'Adressen verwalten',
    savedCards: 'Gespeicherte Karten',
    preferences: 'Einstellungen',
    passwordAnd2FA: 'Passwort & 2FA',
    language: 'Sprache',
    helpSupport: '24/7 Unterstützung',
    logout: 'Abmelden',
    confirmLogout: 'Abmeldung bestätigen',
    confirmLogoutDesc: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    uploadProfilePicture: 'Profilbild hochladen',
    clickToUpload: 'Klicken oder Datei hierher ziehen',
    chooseFile: 'Datei auswählen',
    version: 'BAZARAK v1.0.0',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutz',
    backToProfile: 'Zurück zum Profil',
    welcomeBack: 'Willkommen zurück, {{name}}',
    yourPoints: 'Ihre Punkte',
    yourLevel: 'Ihr Level',
    levelBronze: 'Bronze',
    levelSilver: 'Silber',
    levelGold: 'Gold',
    levelDiamond: 'Diamant',
    levelLegend: 'Legende',
    pointsToNext: 'Noch {{count}} Punkte bis zum nächsten Level',
    maxLevel: 'Höchstes Level erreicht',
    memberOfSince: 'Bazaarak-Mitglied seit {{date}}',
    proTitle: 'Bazaarak Pro',
    proDesc: 'Ein luxuriöseres Erlebnis mit besonderen Vorteilen',
    proUpgrade: 'Auf Pro upgraden',
    proExtend: 'Pro verlängern',
    proActive: 'Aktiv',
    proActivated: 'Pro-Mitgliedschaft aktiviert',
    proActiveUntil: 'Aktiv bis {{date}}',
    proBenefitShipping: 'Kostenloser Versand',
    proBenefitDiscounts: 'Exklusive Rabatte',
    proBenefitSupport: 'Prioritäts-Support',
    proBenefitReturns: 'Kostenlose Rückgabe',
    proComingSoon: 'Pro-Mitgliedschaft kommt bald',
    inviteTitle: 'Freunde einladen',
    inviteDesc: 'Lade Freunde ein und verdiene Punkte und Prämien',
    inviteCode: 'Dein Einladungscode',
    inviteCta: 'Einladen und Punkte verdienen',
    inviteCopied: 'Einladungscode kopiert',
    enterInviteCode: 'Einladungscode eingeben',
    applyInvite: 'Code anwenden',
    referralApplied: 'Empfehlungsbonus angewendet',
    referralBonusHint: 'Du und dein Freund erhalten je {{count}} Punkte',
    shareInviteText: 'Komm zu Bazaarak! Mein Code: {{code}}',
    orderAll: 'Alle Bestellungen',
    orderProcessing: 'In Bearbeitung',
    orderShipped: 'Versendet',
    orderDelivered: 'Zugestellt',
    orderReturns: 'Rückgaben',
    accountInfo: 'Kontoinformationen',
    giftCards: 'Geschenkkarten',
    giftCardsSoon: 'Geschenkkarten kommen bald',
    supportHelp: 'Hilfe & Support',
    settings: 'Einstellungen',
    levelPlatinum: 'Platin',
    pullForMemberPass: 'Nach unten ziehen — Mitglieder-Pass',
    pullToHidePass: 'Nach oben ziehen zum Schließen',
    memberPassEyebrow: 'Mitgliederclub',
    memberPassTitle: 'Bazaarak — Bringing Home Closer',
    memberPassSubtitle: 'Dein {{level}}-Status freischaltet Festival-Vorteile',
    yourQrCode: 'Dein QR-Code',
    scanToInvite: 'Freunde scannen diesen Code und treten mit deiner Einladung bei',
    festivalPerksTitle: 'Deine Festival-Vorteile',
    festivalPerkAccess: 'Zugang zum Festivalbereich',
    festivalPerkDiscount: 'Festival-Rabatte',
    festivalPerkGift: 'Spezielle Geschenke & Verpackung',
    festivalPerkPoints: 'Doppelte Punkte im Festival',
    festivalPerkVip: 'VIP-Zugang zu Events',
    festivalPerkEarly: 'Frühzugang zu Sales',
  },
  wishlist: {
    title: 'Meine Wunschliste',
    saved: 'gespeichert',
    totalValue: 'Gesamtwert',
    potentialSavings: 'Mögliche Ersparnisse',
    inStock: 'Auf Lager',
    addToCart: 'In den Warenkorb',
    addAllToCart: 'Alle in den Warenkorb',
    shareWishlist: 'Wunschliste teilen',
    empty: 'Ihre Wunschliste ist leer',
    emptyDesc: 'Fügen Sie Produkte hinzu, die Ihnen gefallen',
    startShopping: 'Einkaufen beginnen',
    signIn: 'Bitte anmelden',
    signInDesc: 'Anmelden, um Wunschliste zu sehen',
    removedFromWishlist: 'Von der Wunschliste entfernt',
    failedToLoad: 'Wunschliste konnte nicht geladen werden',
    backToProfile: 'Zurück zum Profil',
  },
  vendor: {
    dashboard: 'Verkäufer-Dashboard',
    manageDashboard: 'Verwalten Sie Ihren Shop und verfolgen Sie die Leistung',
    editStore: 'Shop bearbeiten',
    addProduct: 'Produkt hinzufügen',
    createStory: 'Story erstellen',
    overview: 'Übersicht',
    overviewTab: 'Übersicht',
    productsTab: 'Produkte',
    storiesTab: 'Stories',
    analyticsTab: 'Analytik',
    totalSales: 'Gesamtumsatz',
    orders: 'Bestellungen',
    products: 'Produkte',
    customers: 'Kunden',
    recentOrders: 'Aktuelle Bestellungen',
    viewAll: 'Alle anzeigen',
    inventoryAlerts: 'Bestandswarnungen',
    manageInventory: 'Bestand verwalten',
    myStories: 'Meine Stories',
    stories: 'Stories',
    editStoreInfo: 'Shopinformationen bearbeiten',
    addNewProduct: 'Neues Produkt hinzufügen',
    editProduct: 'Produkt bearbeiten',
    createNewStory: 'Neue Story erstellen',
    editStory: 'Story bearbeiten',
    stripeAlertTitle: 'Stripe-Konto nicht verbunden',
    stripeAlertDesc: 'Verbinden Sie zuerst Ihr Stripe-Konto, um Umsatz aus Produktverkäufen zu erzielen. Ohne dieses können keine Produkte hinzugefügt werden.',
    stripeConnectBtn: 'Stripe-Konto verbinden',
    stripeConnecting: 'Verbinden...',
    stripeNoEmail: 'Shop-E-Mail ist nicht festgelegt. Bitte geben Sie zuerst eine E-Mail in den Shop-Einstellungen ein.',
    stripeConnectFailed: 'Stripe-Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    stripeStatusTitle: 'Stripe-Status',
    stripeNotConnected: 'Stripe-Konto nicht verbunden',
    stripeActive: 'Aktiv',
    stripeInactive: 'Inaktiv',
    stripeCanSell: 'Sie können Produkte verkaufen',
    stripeCannotSell: 'Verkauf noch nicht möglich',
    stripeAccountId: 'Konto-ID',
    stripeContinueOnboarding: 'Onboarding fortsetzen',
    stripeResetBtn: 'Stripe zurücksetzen',
    stripeResetTitle: 'Stripe-Konto zurücksetzen',
    stripeResetDesc: 'Sind Sie sicher? Dies entfernt Ihr Stripe-Konto und Sie müssen es erneut verbinden.',
    stripeResetConfirm: 'Ja, zurücksetzen',
    stripeResetting: 'Zurücksetzen...',
    stripeResetFailed: 'Zurücksetzen des Stripe-Kontos fehlgeschlagen',
    stripeProductsBlockTitle: 'Stripe verbinden, um Produkte hinzuzufügen',
    stripeProductsBlockDesc: 'Ihr Shop ist noch nicht mit Stripe verbunden. Schließen Sie die Verbindung im Haupt-Dashboard ab.',
    stripeBlockTitle: 'Stripe-Verbindung erforderlich',
    stripeBlockDesc: 'Um Produkte hinzuzufügen und Umsatz zu erzielen, müssen Sie zuerst Ihr Stripe-Konto verbinden.',
    fillRequired: 'Bitte füllen Sie alle Pflichtfelder aus',
    saveFailed: 'Produkt konnte nicht gespeichert werden',
    deleteFailed: 'Produkt konnte nicht gelöscht werden',
    storeNameLabel: 'Shopname',
    storeDescLabel: 'Shopbeschreibung',
    ordersEmpty: 'Noch keine Bestellungen',
    salesLabel: 'Verkäufe',
    stockLeft: 'verbleibend',
    lowStock: 'Wenig auf Lager',
    revenueLabel: 'Umsatz',
    categoryLabel: 'Kategorie',
    orderLabel: 'Bestellung',
    itemsLabel: 'Artikel',
    guestCustomer: 'Gast',
    noProductsYet: 'Noch keine Produkte',
    addProductDesc: 'Fügen Sie Ihr erstes Produkt hinzu, um mit dem Verkauf zu beginnen',
    productNameLabel: 'Produktname',
    productNamePlaceholder: 'Produktname eingeben',
    otherCategory: 'Sonstiges',
    productDescPlaceholder: 'Produktbeschreibung eingeben...',
    productImageLabel: 'Produktbild',
    uploading: 'Hochladen...',
    uploadImage: 'Bild hochladen',
    deleteProductTitle: 'Produkt löschen?',
    deleteProductDesc: 'Sind Sie sicher, dass Sie löschen möchten',
    noProducts: 'Noch keine Produkte',
    uploadNetworkError: 'Bildupload über Server nicht verfügbar. Bitte geben Sie eine Bild-URL ein.',
    useImageUrl: 'Bild-URL',
    hideUrl: 'URL schließen',
    imageUrlHint: 'Wenn der Bildupload nicht funktioniert, geben Sie den direkten Bildlink ein:',
    imageUrlPlaceholder: '/uploads/example.jpg',
    applyUrl: 'Anwenden',
  },
  notifications: {
    title: 'Benachrichtigungen',
    unread: 'ungelesen',
    markAllRead: 'Alle als gelesen markieren',
    allNotifications: 'Alle',
    unreadNotifications: 'Ungelesen',
    noNotifications: 'Keine Benachrichtigungen',
    noNotificationsDesc: 'Alles aktuell! Schauen Sie später wieder vorbei.',
    markRead: 'Als gelesen markieren',
  },
  addresses: {
    title: 'Meine Adressen',
    yourAddresses: 'Deine Adressen',
    saved: 'gespeichert',
    location: 'Standort',
    locations: 'Standorte',
    addNew: 'Neu hinzufügen',
    noAddresses: 'Noch keine Adressen',
    noAddressesDesc: 'Fügen Sie Ihre erste Lieferadresse hinzu',
    addAddress: 'Adresse hinzufügen',
    signIn: 'Bitte anmelden',
    signInDesc: 'Anmelden, um Adressen zu verwalten',
    addNewAddress: 'Neue Adresse hinzufügen',
    editAddress: 'Adresse bearbeiten',
    deleteAddress: 'Adresse löschen?',
    deleteAddressDesc: 'Sind Sie sicher, dass Sie löschen möchten',
    cannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    setDefault: 'Als Standard',
    backToProfile: 'Zurück zum Profil',
    default: 'Standard',
    searchTab: 'Suche',
    savedTab: 'Gespeichert',
    resultsFound: 'Ergebnisse',
    startTypingHint: 'Beginnen Sie mit der Eingabe Ihrer Adresse...',
    editPin: 'Pin bearbeiten',
    locationType: 'Standorttyp',
    apartment: 'Wohnung',
    house: 'Haus',
    office: 'Büro',
    doorbellName: 'Name an der Klingel',
    doorbellNamePlaceholder: 'z.B. "Max Mustermann"',
    entrance: 'Eingang',
    entrancePlaceholder: 'z.B. "Eingang B"',
    additionalInfo: 'Zusätzliche Info für den Fahrer',
    additionalInfoPlaceholder: 'Hinweise für den Fahrer...',
    addressRequired: 'Bitte wählen Sie eine Adresse',
    phoneRequired: 'Telefonnummer ist erforderlich',
  },
  payment: {
    title: 'Zahlungsmethoden',
    saved: 'gespeichert',
    method: 'Methode',
    methods: 'Methoden',
    addNew: 'Neu hinzufügen',
    noPaymentMethods: 'Noch keine Zahlungsmethoden',
    noPaymentMethodsDesc: 'Fügen Sie Ihre erste Zahlungsmethode hinzu',
    addPaymentMethod: 'Zahlungsmethode hinzufügen',
    savePaymentMethod: 'Zahlungsmethode speichern',
    addPaymentMethodTitle: 'Zahlungsmethode hinzufügen',
    setDefault: 'Als Standard',
    default: 'Standard',
    deletePaymentMethod: 'Zahlungsmethode löschen?',
    deleteDesc: 'Sind Sie sicher, dass Sie diese Zahlungsmethode löschen möchten?',
    backToProfile: 'Zurück zum Profil',
    card: 'Karte',
    paypal: 'PayPal',
    bank: 'Bank',
    cardNumber: 'Kartennummer',
    cardHolder: 'Karteninhaber',
    expiryDate: 'Ablaufdatum',
    cvv: 'CVV',
    cardType: 'Kartentyp',
    paypalEmail: 'PayPal E-Mail',
    bankName: 'Bankname',
    accountNumber: 'Kontonummer',
    setAsDefault: 'Als Standard-Zahlungsmethode',
    cardHolder_placeholder: 'Name auf der Karte',
    editPaymentMethod: 'Zahlungsmethode bearbeiten',
    saveChanges: 'Änderungen speichern',
    expires: 'Gültig bis',
    cardHolderLabel: 'Karteninhaber',
  },
  security: {
    title: 'Sicherheitseinstellungen',
    manageDesc: 'Verwalten Sie die Sicherheit Ihres Kontos',
    changePassword: 'Passwort ändern',
    changePasswordDesc: 'Aktualisieren Sie Ihr Kontopasswort',
    twoFA: 'Zwei-Faktor-Authentifizierung',
    biometric: 'Biometrische Anmeldung',
    activeSessions: 'Aktive Sitzungen',
    loginHistory: 'Anmeldeverlauf',
    viewRecentActivity: 'Letzte Aktivität anzeigen',
    deleteAccount: 'Konto löschen',
    deleteDesc: 'Konto dauerhaft entfernen',
    recentLoginActivity: 'Letzte Anmeldeaktivität',
    enable2FA: '2FA aktivieren',
    disable2FA: '2FA deaktivieren',
    sessions: 'aktive Geräte',
    enable2FATitle: 'Zwei-Faktor-Authentifizierung aktivieren',
    disable2FATitle: 'Zwei-Faktor-Authentifizierung deaktivieren',
    enable2FADesc: 'Fügen Sie Ihrem Konto mit 2FA eine zusätzliche Sicherheitsebene hinzu.',
    disable2FADesc: 'Ohne 2FA-Schutz ist Ihr Konto weniger sicher.',
    activeSessionsTitle: 'Aktive Sitzungen',
    updatePassword: 'Passwort aktualisieren',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    enterCurrentPassword: 'Aktuelles Passwort eingeben',
    enterNewPassword: 'Neues Passwort eingeben',
    confirmNewPassword: 'Neues Passwort bestätigen',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein!',
    passwordMinLength: 'Passwort muss mindestens 8 Zeichen haben!',
    scanQRCode: 'QR-Code scannen',
    useAuthenticator: 'Google Authenticator oder ähnliche App verwenden',
    success: 'Erfolg',
    failed: 'Fehlgeschlagen',
    backToProfile: 'Zurück zum Profil',
    current: 'Aktuell',
    logout: 'Abmelden',
    deleteAccountTitle: 'Konto löschen',
    deleteAccountDesc: 'Diese Aktion kann nicht rückgängig gemacht werden. Alle Ihre Daten werden dauerhaft gelöscht.',
    deleteWarning: '• Alle Bestellungen und der Kaufverlauf werden gelöscht\n• Gespeicherte Adressen und Zahlungsmethoden werden entfernt\n• Wunschlisten-Artikel gehen verloren\n• Diese Aktion ist unwiderruflich',
  },
  help: {
    title: 'Hilfe & Support',
    subtitle: 'Wir sind 24/7 für Sie da',
    liveChat: 'Live-Chat',
    liveChatDesc: 'Chat mit unserem Support-Team',
    available247: 'Verfügbar 24/7',
    emailSupport: 'E-Mail-Support',
    emailSupportDesc: 'support@bazarak.com',
    responseTime: 'Antwort innerhalb 24 Stunden',
    phoneSupport: 'Telefon-Support',
    phoneSupportDesc: '+49 30 1234 5678',
    monFri: 'Mo-Fr, 9-18 Uhr MEZ',
    whatsapp: 'WhatsApp',
    whatsappDesc: 'Senden Sie uns eine WhatsApp-Nachricht',
    faq: 'Häufig gestellte Fragen',
    allTopics: 'Alle Themen',
    orders: 'Bestellungen',
    payments: 'Zahlungen',
    shipping: 'Versand',
    returns: 'Rückgaben',
    account: 'Konto',
    quickLinks: 'Schnelllinks',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzrichtlinie',
    refund: 'Rückgaberichtlinie',
    shippingPolicy: 'Versandrichtlinie',
    stillNeedHelp: 'Noch Hilfe benötigt?',
    stillNeedHelpDesc: 'Nicht gefunden was Sie suchen? Unser Support-Team hilft Ihnen gerne.',
    contactSupport: 'Support kontaktieren',
    contactSupportTitle: 'Support kontaktieren',
    yourName: 'Ihr Name',
    emailAddress: 'E-Mail-Adresse',
    subject: 'Betreff',
    message: 'Nachricht',
    sendMessage: 'Nachricht senden',
    noFaqFound: 'Keine FAQs in dieser Kategorie gefunden',
    startChat: 'Chat starten',
    sendEmail: 'E-Mail senden',
    callNow: 'Jetzt anrufen',
    openWhatsApp: 'WhatsApp öffnen',
    backToProfile: 'Zurück zum Profil',
    subjectPlaceholder: 'Womit können wir Ihnen helfen?',
    messagePlaceholder: 'Bitte beschreiben Sie Ihr Problem...',
    namePlaceholder: 'Ihren Namen eingeben',
  },
  footer: {
    quickLinks: 'Schnelllinks',
    support: 'Support',
    downloadApp: 'App herunterladen',
    description: 'Bazaarak, Online-Shop für frische und qualitativ hochwertige Produkte. Garantiert beste Preise und schnellste Lieferung.',
    rights: '© 2026 Bazaarak. Alle Rechte vorbehalten.',
    contactUs: 'Kontakt',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutz',
    helpCenter: 'Hilfecenter',
    appStore: 'App Store',
    googlePlay: 'Google Play',
  },
  language: {
    title: 'Sprache',
    persian: 'Persisch',
    english: 'Englisch',
    german: 'Deutsch',
    turkish: 'Türkisch',
    arabic: 'Arabisch',
    selectLanguage: 'Sprache auswählen',
    currentLanguage: 'Aktuelle Sprache',
    availableLanguages: 'Verfügbare Sprachen',
    changeInfo: 'Eine Sprachänderung aktualisiert sofort die gesamte App-Oberfläche.',
    switchConfirm: 'Zu {{name}} ({{native}}) wechseln?',
  },
  datetime: {
    title: 'Lieferung planen',
    quickSelect: 'Schnellauswahl',
    selectDate: 'Datum auswählen',
    selectTime: 'Uhrzeit auswählen',
    today: 'Heute',
    tomorrow: 'Morgen',
    dayAfter: 'Übermorgen',
    nextWeek: 'Nächste Woche',
    su: 'So',
    mo: 'Mo',
    tu: 'Di',
    we: 'Mi',
    th: 'Do',
    fr: 'Fr',
    sa: 'Sa',
    deliveryTo: 'Liefern an',
    pickupFrom: 'Abholung von',
    courierArrives: 'Kurier wird in diesem Zeitfenster ankommen',
    readyForPickup: 'Ihre Bestellung wird zur Abholung bereit sein',
    confirmSchedule: 'Zeitplan bestätigen',
    selectDateTime: 'Datum und Uhrzeit auswählen',
  },
  bazaarHub: {
    title: 'Bazaarak',
    subtitle: 'Alles an einem Ort',
    categories: 'Kategorien',
    search: 'Suchen',
    cart: 'Warenkorb',
    orders: 'Bestellungen',
    profile: 'Profil',
    wishlist: 'Wunschliste',
    offers: 'Angebote',
    vendors: 'Verkäufer',
    addresses: 'Adressen',
    notifications: 'Benachrichtigungen',
    settings: 'Einstellungen',
    help: 'Hilfe',
  },
  theme: {
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
  },
  search: {
    productLabel: 'Produkte',
    categoryLabel: 'Kategorien',
    wishlistLabel: 'Wunschliste',
    offerLabel: 'Angebote',
    addressLabel: 'Adressen',
    vendorLabel: 'Verkäufer',
    for: 'für',
    filteringBy: 'Filtern nach',
    clearCategoryFilter: 'Kategoriefilter löschen',
    relevance: 'Relevanz',
    priceLowToHigh: 'Preis: Niedrig zu Hoch',
    priceHighToLow: 'Preis: Hoch zu Niedrig',
    newest: 'Neueste',
    topRated: 'Top Bewertet',
    allPrices: 'Alle Preise',
    allRatings: 'Alle Bewertungen',
    sortBy: 'Sortieren nach',
    priceRange: 'Preisbereich',
    rating: 'Bewertung',
    filters: 'Filter',
    applyFilters: 'Filter anwenden',
    clearAllFilters: 'Alle Filter löschen',
    brand: 'Marke',
    color: 'Farbe',
    size: 'Größe',
    allBrands: 'Alle Marken',
    allColors: 'Alle Farben',
    allSizes: 'Alle Größen',
    noBrands: 'Keine Marken verfügbar',
    noColors: 'Keine Farben verfügbar',
    noSizes: 'Keine Größen verfügbar',
    typeToFind: 'Tippen, um Produkte, Kategorien und mehr zu finden',
    resultsFor: 'Suchergebnisse für',
    resultsFound: 'Ergebnisse gefunden',
    items: 'Artikel',
    stores: 'Shops',
    categories: 'Kategorien',
    itemFound: 'Artikel',
    storeFound: 'Shop',
    categoryFound: 'Kategorie',
    tryDifferentKeywords: 'Andere Suchbegriffe versuchen',
    noProductsFound: 'Keine Produkte gefunden',
    noStoresFound: 'Keine Shops gefunden',
    noCategoriesFound: 'Keine Kategorien gefunden',
  },
  aiAssistant: {
    title: 'KI-Assistent',
    subtitle: 'Wie kann ich Ihnen helfen?',
    hotDeals: 'Heiße Angebote',
    trackOrder: 'Bestellung verfolgen',
    popular: 'Beliebt',
    findStores: 'Shops finden',
    comingSoon: 'Intelligente KI-Funktionen kommen bald!',
    askAnything: 'Fragen Sie etwas...',
    errorReply: 'Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
  },
  stores: {
    title: 'Alle Shops',
    stores: 'Shop',
    searchPlaceholder: 'Shops nach Name, Stadt oder Tag suchen...',
    sortPopular: 'Beliebt',
    sortRating: 'Top Bewertet',
    sortNewest: 'Neueste',
    sortProducts: 'Meiste Produkte',
    endOfList: 'Ende der Liste',
  },
  errors: {
    loadFailed: 'Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    noResults: 'Keine Ergebnisse gefunden',
  },
  admin: {
    title: 'Admin-Panel',
    menu: 'Menü',
    backToSite: 'Zurück zur Website',
    dashboard: 'Dashboard',
    users: 'Benutzer',
    stores: 'Shops',
    products: 'Produkte',
    orders: 'Bestellungen',
    categories: 'Kategorien',
    search: 'In diesem Bereich suchen...',
    totalUsers: 'Gesamtbenutzer',
    totalStores: 'Gesamtshops',
    totalProducts: 'Gesamtprodukte',
    totalOrders: 'Gesamtbestellungen',
    totalRevenue: 'Gesamtumsatz',
    pendingOrders: 'Ausstehende Bestellungen',
    quickActions: 'Schnellaktionen',
    addCategory: 'Kategorie hinzufügen',
    addProduct: 'Produkt hinzufügen',
    viewOrders: 'Bestellungen anzeigen',
    manageUsers: 'Benutzer verwalten',
    name: 'Name',
    email: 'E-Mail',
    role: 'Rolle',
    joined: 'Beitrittsdatum',
    storeName: 'Shopname',
    address: 'Adresse',
    rating: 'Bewertung',
    products: 'Produkte',
    productName: 'Produktname',
    price: 'Preis',
    stock: 'Bestand',
    status: 'Status',
    orderId: 'Bestell-ID',
    customer: 'Kunde',
    total: 'Gesamt',
    date: 'Datum',
    categoryName: 'Kategoriename',
    parentCategory: 'Übergeordnete Kategorie',
    mainCategory: 'Hauptkategorie',
    noneTopLevel: 'Keine (Oberste Ebene)',
    sortOrder: 'Sortierung',
    confirmDelete: 'Löschen bestätigen',
    confirmDeleteDesc: 'Sind Sie sicher, dass Sie diesen Artikel löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    edit: 'Bearbeiten',
    canAddProducts: 'Produkt hinzufügen erlauben',
  },
};